<template>
  <div class="inline-unit-form">
    <div class="inline-form-grid">
      <div class="inline-form-group inline-form-group--wide">
        <base-label :required="true">Название</base-label>
        <base-input
          v-model="form.name"
          placeholder="Например: Личный счет, Корпоративная карта..."
          :invalid="errors.name"
          @update:modelValue="errors.name = false"
        />
        <span v-if="errors.name" class="error-message">
          Это поле обязательно
        </span>
      </div>

      <div class="inline-form-group inline-form-group--wide">
        <base-label>Название банка</base-label>
        <base-input
          v-model="form.bank_name"
          placeholder="Альфа-Банк, Сбербанк..."
        />
      </div>
    </div>

    <div class="inline-form-actions">
      <base-primary-button
        @click="save"
        :loading="isLoading"
        class="btn-sm"
      >
        {{ submitLabel }}
      </base-primary-button>
      <base-button @click="$emit('cancel')" class="btn-sm">
        Отмена
      </base-button>
    </div>
  </div>
</template>

<script>
import { useNotificationStore } from "@/stores/notificationStore";

export default {
  name: "PaymentSourceForm",
  props: {
    initialData: { type: Object, default: null },
    isLoading: { type: Boolean, default: false },
    submitLabel: { type: String, default: "Сохранить" },
  },
  emits: ["save", "cancel"],
  data() {
    return {
      form: {
        name: "",
        bank_name: "",
      },
      errors: {
        name: false,
      },
    };
  },
  computed: {
    notificationStore() {
      return useNotificationStore();
    },
  },
  methods: {
    initForm() {
      if (!this.initialData) return;
      this.form = {
        name: this.initialData.name || "",
        bank_name: this.initialData.bank_name || "",
      };
    },

    validate() {
      let isValid = true;
      this.errors = { name: false };

      if (!String(this.form.name).trim()) {
        this.errors.name = true;
        isValid = false;
      }

      if (!isValid) {
        this.notificationStore.showError(
          "Пожалуйста, заполните все обязательные поля корректно"
        );
      }

      return isValid;
    },

    save() {
      if (!this.validate()) {
        this.$nextTick(() => {
          const firstErrorElement = document.querySelector(
            ".invalid, .error-message"
          );
          if (firstErrorElement) {
            const formGroup = firstErrorElement.closest(
              ".inline-form-group"
            );
            (formGroup || firstErrorElement).scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        });
        return;
      }

      this.$emit("save", {
        name: this.form.name,
        bank_name: this.form.bank_name,
      });
    },
  },
  created() {
    this.initForm();
  },
};
</script>

<style scoped>
.inline-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: var(--base-in-indent);
}

.inline-form-group {
  display: flex;
  flex-direction: column;
}

.inline-form-group--wide {
  grid-column: span 2;
}

.inline-form-actions {
  display: flex;
  gap: 8px;
}

.btn-sm {
  padding: 6px 14px;
  font-size: 13px;
}

.error-message {
  margin-top: 5px;
  color: var(--color-danger);
  font-size: 12px;
}

@media (max-width: 600px) {
  .inline-form-grid {
    grid-template-columns: 1fr;
  }

  .inline-form-group--wide {
    grid-column: span 1;
  }
}
</style>
